var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21843 8.67224H4.95124C5.11062 8.67224 5.26218 8.59568 5.35593 8.46599L6.99968 6.19412L8.64343 8.46599C8.73718 8.59568 8.88718 8.67224 9.04812 8.67224H9.78093C9.88249 8.67224 9.94187 8.55662 9.88249 8.4738L7.10124 4.63005C7.05124 4.5613 6.94968 4.5613 6.89968 4.63005L4.11843 8.4738C4.05749 8.55662 4.11687 8.67224 4.21843 8.67224Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8656 14 14 10.8656 14 7C14 3.13437 10.8656 0 7 0C3.13437 0 0 3.13437 0 7C0 10.8656 3.13437 14 7 14ZM7 1.1875C10.2094 1.1875 12.8125 3.79062 12.8125 7C12.8125 10.2094 10.2094 12.8125 7 12.8125C3.79062 12.8125 1.1875 10.2094 1.1875 7C1.1875 3.79062 3.79062 1.1875 7 1.1875Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpCircle);
export default __webpack_public_path__ + "97120/static/media/up-circle.ec9d6c5822c6f7e43672c5b639470398.svg";
export { ForwardRef as ReactComponent };